/*
 *             Copyright (c) 2016 - 2021, CKSource - Frederico Knabben. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import{Plugin as _0x105cd7}from'ckeditor5/src/core';import'../../theme/integrations/pagebreak.css';export default class at extends _0x105cd7{['afterInit'](){const _0xf982e2=this['editor'];if(!_0xf982e2['plugins']['has']('PageBreakEditing'))return;_0xf982e2['plugins']['get']('TrackChangesEditing')['enableCommand']('pageBreak');const _0xd20fd6=_0xf982e2['plugins']['get']('TrackChangesEditing'),{t:t}=_0xf982e2['locale'];_0xd20fd6['_descriptionFactory']['registerElementLabel']('pageBreak',_0xe600e9=>t({'string':'page\x20break','plural':'%0\x20page\x20breaks','id':'ELEMENT_PAGE_BREAK'},_0xe600e9));}}